<template>
    <div>
        <div 
            v-show="!isMobileView"
            @click="() => { clickHandler()}"
            class="wheelSeg"
            v-bind:style="{
                position: 'absolute',
                height: matrix + 'px',
                width: matrix + 'px',
                transform: 'rotate(' + rotation + 'deg)',
                transformOrigin: 'center',
                zIndex: 100,
                ...( (positionTop || positionTop == 0) && { top: positionTop + 'px'}),
                ...( (positionLeft || positionLeft == 0) && { left: positionLeft + 'px'}),
                ...( (positionRight || positionRight == 0) && { right: positionRight + 'px'}),
                ...( (positionBottom || positionBottom == 0) && { bottom: positionBottom + 'px'})
            }"
            @mouseenter="() => { hoverActive = true}"
            @mouseleave="() => { hoverActive = false}"
        >
            <div 
                v-if="hoverActive || initialDefaultHoveredValues[wheelSegmentIndex]"
                class="wheelSegGutsHover"
                v-bind:style="{
                    height: matrix + (matrix * .20) + 'px',
                    width: matrix + (matrix * .20) + 'px'
                }"
            >
                <img alt="image caption" class="img-fluid"  :src="hoverImage" />
            </div>

            <div v-if="!hoverActive" class="wheelSegGuts">
                <img alt="image caption" class="img-fluid"  :src="defaultImage" />
            </div>

            <!-- <img v-if="hoverActive" alt="image caption" class="img-fluid"  :src="hoverImage" /> -->
        </div>
    </div>
</template>

<script>
export default {
  name: "WheelSeg",
  components: {
  },
  props: [
    'matrix',
    'rotation',
    'defaultImage',
    'hoverImage',
    'positionTop',
    'positionRight',
    'positionBottom',
    'positionLeft',
    'clickHandler',
    'isMobileView',
    'wheelSegmentIndex',
    'initialDefaultHoveredValues',
  ],
  data() {
    return ({
        hoverActive: false
    })
  },
  watch: {
    hoverActive(newValue){
        if(newValue) {
            const isAnyDefaultHovered = this.initialDefaultHoveredValues?.some(item => item === true);
            if(isAnyDefaultHovered) {
                const defaultHoverIndex = this.initialDefaultHoveredValues.findIndex(item => item === true);
                this.$emit("resetDefaultHoverValues", { defaultIndex: defaultHoverIndex, isEnlarged: this.wheelSegmentIndex === defaultHoverIndex });
            }
        }
        else {
            // "Why Project Spectrum?" wheel segment index is 1.
            if(this.wheelSegmentIndex !== 1) {
                this.$emit("resetDefaultHoverValues", { defaultIndex: 1, isEnlarged: this.wheelSegmentIndex !== 1 });
            }
        }
    }
  }
}
</script>

<style>

.wheelSeg {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wheelSegGuts {
    width: 100%;
    height: 100%;
    -webkit-mask-image: url('../../../assets/images/spectrum-wheel/wheel-segment-mask.svg');
    mask-image: url('../../../assets/images/spectrum-wheel/wheel-segment-mask.svg');
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    mask-size: contain;
}

.wheelSegGutsHover {
    position: absolute;
    z-index: 150;
    -webkit-mask-image: url('../../../assets/images/spectrum-wheel/wheel-segment-mask.svg');
    mask-image: url('../../../assets/images/spectrum-wheel/wheel-segment-mask.svg');
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    mask-size: contain;
}

</style>